import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import useSendEventGA from "hooks/useSendEventGA";
import "styles/HeroNavbar.css";
import { PhoneOutgoing } from "lucide-react";
import { ReactComponent as LogoElite } from "../assets/patterns/eliteVacances.svg";
import { ReactComponent as Afiliado } from "../assets/patterns/afiliado.svg";
import { ReactComponent as FacebookSVG } from "assets/patterns/Facebook.svg";
import { ReactComponent as InstagramSVG } from "assets/patterns/Instagram.svg";
import { ReactComponent as TikTokSVG } from "assets/patterns/TikTok.svg";
import { ReactComponent as PaySVG } from "assets/patterns/Pagos.svg";

const HeroNavbar = ({ isScrolled, isHomePage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const SendEventAfiliado = (e) => {
    e.preventDefault();
    window.open("https://vip.elitevacances.com/", "_blank");
    useSendEventGA(
      "Priority elitevacances",
      "Click en boton Afiliado (Navbar)",
    );
  };

  // En páginas que no son home, el navbar siempre está visible
  const shouldShowNavbar = !isHomePage || isScrolled;

  return (
    <>
      {/* Navbar fijo superior */}
      <nav
        className={`hero-navbar ${
          shouldShowNavbar ? "hero-navbar--visible" : ""
        }`}
      >
        {/* Logo - ocupa 2 filas */}
        <div className="hero-navbar__logo">
          <NavLink to="/" aria-label="Elite Vacances">
            <LogoElite
              className={`hero-navbar__logo-img ${
                shouldShowNavbar ? "hero-navbar--dark" : "hero-navbar--light"
              }`}
            />
          </NavLink>
        </div>

        {/* Menú - segunda fila, columnas del medio */}
        <ul className="hero-navbar__menu">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive
                  ? "hero-navbar__link hero-navbar__link--active"
                  : "hero-navbar__link"
              }
            >
              Inicio
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/hoteles"
              className={({ isActive }) =>
                isActive
                  ? "hero-navbar__link hero-navbar__link--active"
                  : "hero-navbar__link"
              }
            >
              Hoteles
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive
                  ? "hero-navbar__link hero-navbar__link--active"
                  : "hero-navbar__link"
              }
            >
              Nosotros
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/promotions"
              className={({ isActive }) =>
                isActive
                  ? "hero-navbar__link hero-navbar__link--active"
                  : "hero-navbar__link"
              }
            >
              Promociones
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contacto"
              className={({ isActive }) =>
                isActive
                  ? "hero-navbar__link hero-navbar__link--active"
                  : "hero-navbar__link"
              }
            >
              Contáctanos
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/pagos"
              className={({ isActive }) =>
                isActive
                  ? "hero-navbar__link hero-navbar__link--active"
                  : "hero-navbar__link"
              }
            >
              pagos
            </NavLink>
          </li>
        </ul>

        {/* Botón hamburguesa para móvil - solo visible en desktop, en móvil va al topbar */}
        <button className="hero-navbar__hamburger">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      {/* Barra superior con redes sociales y botones (siempre en misma posición, encima del navbar) */}
      <div className="hero-navbar__topbar">
        <div
          className={`hero-navbar__social-icons ${shouldShowNavbar ? "hero-navbar__social-icons--dark" : "hero-navbar__social-icons--light"}`}
        >
          <a
            href="https://facebook.com/elitevacances"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookSVG className="social-link" />
          </a>
          <a
            href="https://www.instagram.com/elitevacances/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramSVG className="social-link" />
          </a>
          <a
            href="https://www.tiktok.com/@elitevacances"
            target="_blank"
            rel="noopener noreferrer"
          >
            <TikTokSVG className="social-link" />
          </a>
          <a
            href="https://wa.me/5717945996"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PhoneOutgoing className="social-link" />
          </a>
          <span className={shouldShowNavbar ? "text--dark" : "text--light"}>
            +57 (1) 7945996
          </span>
          {/* <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noreferrer"
            className="hero-navbar__social-icon"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/EliteVacances/Icons/Iconos en SVG_Instagram.svg`}
              alt="Instagram"
            />
          </a>
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noreferrer"
            className="hero-navbar__social-icon"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/EliteVacances/Icons/Iconos en SVG_Facebook.svg`}
              alt="Facebook"
            />
          </a>
          <a
            href="https://www.tiktok.com/?lang=es"
            target="_blank"
            rel="noreferrer"
            className="hero-navbar__social-icon"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/EliteVacances/Icons/Iconos en SVG_TikTok.svg`}
              alt="TikTok"
            />
          </a>
          <a href="tel:+576015520100" className="hero-navbar__phone">
            <img
              src={`${process.env.PUBLIC_URL}/images/EliteVacances/Icons/Iconos en SVG_Contacto.svg`}
              alt="Teléfono"
              className="hero-navbar__phone-icon"
            />
            <span>(601)5520100</span>
          </a> */}
        </div>
        <div className="hero-navbar__topbar-buttons">
          <button
            className={`hero-navbar__btn-afiliado ${shouldShowNavbar ? "hero-navbar__logo-img--dark" : "hero-navbar--light"}`}
            onClick={SendEventAfiliado}
          >
            {/* <img
              src={`${process.env.PUBLIC_URL}/images/EliteVacances/Icons/Iconos en SVG_Afiliado.svg`}
              alt="Afiliado"
              className="hero-navbar__btn-icon"
            /> */}
            <Afiliado className="hero-navbar__btn-icon" />
            Afiliado
          </button>
        </div>
        {/* Hamburguesa en móvil - debajo de las redes sociales */}
        <button
          className={`hero-navbar__topbar-hamburger ${
            isMenuOpen ? "hero-navbar__topbar-hamburger--active" : ""
          }`}
          onClick={toggleMenu}
          aria-label="Abrir menú"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Menú móvil desplegable - Luxury style */}
      <div
        className={`hero-navbar__mobile-menu ${
          isMenuOpen ? "hero-navbar__mobile-menu--open" : ""
        }`}
      >
        <div
          className="hero-navbar__mobile-menu-overlay"
          onClick={closeMenu}
        ></div>
        <div className="hero-navbar__mobile-menu-content">
          <div className="hero-navbar__mobile-menu-header">
            <LogoElite className="hero-navbar__mobile-menu-logo-svg" />
          </div>
          <nav className="hero-navbar__mobile-menu-nav">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `hero-navbar__mobile-menu-link ${
                  isActive ? "hero-navbar__mobile-menu-link--active" : ""
                }`
              }
              onClick={closeMenu}
            >
              <span className="hero-navbar__mobile-menu-link-text">Inicio</span>
              <span className="hero-navbar__mobile-menu-link-line"></span>
            </NavLink>
            <NavLink
              to="/hoteles"
              className={({ isActive }) =>
                `hero-navbar__mobile-menu-link ${
                  isActive ? "hero-navbar__mobile-menu-link--active" : ""
                }`
              }
              onClick={closeMenu}
            >
              <span className="hero-navbar__mobile-menu-link-text">
                Hoteles
              </span>
              <span className="hero-navbar__mobile-menu-link-line"></span>
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `hero-navbar__mobile-menu-link ${
                  isActive ? "hero-navbar__mobile-menu-link--active" : ""
                }`
              }
              onClick={closeMenu}
            >
              <span className="hero-navbar__mobile-menu-link-text">
                Nosotros
              </span>
              <span className="hero-navbar__mobile-menu-link-line"></span>
            </NavLink>
            <NavLink
              to="/contacto"
              className={({ isActive }) =>
                `hero-navbar__mobile-menu-link ${
                  isActive ? "hero-navbar__mobile-menu-link--active" : ""
                }`
              }
              onClick={closeMenu}
            >
              <span className="hero-navbar__mobile-menu-link-text">
                Contáctanos
              </span>
              <span className="hero-navbar__mobile-menu-link-line"></span>
            </NavLink>
            <NavLink
              to="/promotions"
              className={({ isActive }) =>
                `hero-navbar__mobile-menu-link ${
                  isActive ? "hero-navbar__mobile-menu-link--active" : ""
                }`
              }
              onClick={closeMenu}
            >
              <span className="hero-navbar__mobile-menu-link-text">
                Promociones
              </span>
              <span className="hero-navbar__mobile-menu-link-line"></span>
            </NavLink>
          </nav>
          <div className="hero-navbar__mobile-menu-footer">
            <NavLink
              to="/pagos"
              className="hero-navbar__mobile-menu-btn"
              onClick={closeMenu}
            >
              {/* <img

                src={`${process.env.PUBLIC_URL}/images/EliteVacances/Icons/Iconos en SVG_Pagos.svg`}
                alt="Pagos"
                className="hero-navbar__mobile-menu-btn-icon"
              /> */}
              <PaySVG className="hero-navbar__mobile-menu-btn-icon" />
              Pagos
            </NavLink>
            <button
              className="hero-navbar__mobile-menu-btn hero-navbar__mobile-menu-btn--gold"
              onClick={(e) => {
                SendEventAfiliado(e);
                closeMenu();
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/EliteVacances/Icons/Iconos en SVG_Afiliado.svg`}
                alt="Afiliado"
                className="hero-navbar__mobile-menu-btn-icon"
              />
              Afiliado
            </button>
            {/* <div className="hero-navbar__mobile-menu-social">
              <a
                href="https://www.instagram.com/elitevacances/"
                target="_blank"
                rel="noreferrer"
              >
                <InstagramSVG className="hero-navbar__mobile-menu-btn-icon" />
              </a>
              <a
                href="https://facebook.com/elitevacances"
                target="_blank"
                rel="noreferrer"
              >
                <FacebookSVG className="hero-navbar__mobile-menu-btn-icon" />
              </a>
              <a
                href="https://www.tiktok.com/@elitevacances"
                target="_blank"
                rel="noreferrer"
              >
                <TikTokSVG className="hero-navbar__mobile-menu-btn-icon" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroNavbar;
